import { useEffect, useState } from "react";
import { SiteFooter, SiteHeader, normalizePath } from "./components/layout.jsx";
import { CaseStudyPage } from "./pages/CaseStudyPage.jsx";
import { DesignSystemPage } from "./pages/DesignSystemPage.jsx";
import { HomePage } from "./pages/HomePage.jsx";
import { PatternsPage } from "./pages/PatternsPage.jsx";
import { ProtocolPage } from "./pages/ProtocolPage.jsx";

const titles = {
  "/": "Specification Architecture — KeepStraight",
  "/patterns": "Pattern bank — Specification Architecture",
  "/protocol": "MCP surface — Specification Architecture",
  "/case-study": "Case study — Specification Architecture",
  "/design-system": "Design — Specification Architecture"
};

function currentRoute() {
  return normalizePath(window.location.pathname);
}

function scrollToCurrentHash() {
  if (!window.location.hash) {
    return;
  }
  const target = document.querySelector(window.location.hash);
  if (!target) {
    return;
  }
  const headerOffset = document.querySelector(".site-header")?.offsetHeight ?? 0;
  window.scrollTo(0, target.getBoundingClientRect().top + window.scrollY - headerOffset - 12);
}

export function App() {
  const [route, setRoute] = useState(currentRoute());

  useEffect(() => {
    function navigate(url) {
      window.history.pushState({}, "", `${url.pathname}${url.hash}`);
      setRoute(normalizePath(url.pathname));
      window.setTimeout(() => {
        if (url.hash) {
          scrollToCurrentHash();
        } else {
          window.scrollTo({ top: 0 });
        }
      }, 0);
    }

    function onClick(event) {
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      const anchor = event.target.closest("a[href]");
      if (!anchor || anchor.target === "_blank" || anchor.origin !== window.location.origin) {
        return;
      }
      const path = anchor.pathname;
      if (/\.(json|md|svg)$/.test(path)) {
        return;
      }
      event.preventDefault();
      navigate(new URL(anchor.href));
    }

    function onPop() {
      setRoute(currentRoute());
    }

    document.addEventListener("click", onClick);
    window.addEventListener("popstate", onPop);
    return () => {
      document.removeEventListener("click", onClick);
      window.removeEventListener("popstate", onPop);
    };
  }, []);

  useEffect(() => {
    document.title = titles[route] || titles["/"];
    window.setTimeout(scrollToCurrentHash, 0);
    window.setTimeout(scrollToCurrentHash, 150);
  }, [route]);

  const page = {
    "/": <HomePage />,
    "/patterns": <PatternsPage />,
    "/protocol": <ProtocolPage />,
    "/case-study": <CaseStudyPage />,
    "/design-system": <DesignSystemPage />
  }[route] || <HomePage />;

  return (
    <>
      <SiteHeader currentPath={route} />
      {page}
      <SiteFooter />
    </>
  );
}
